import { render, staticRenderFns } from "./xdd.vue?vue&type=template&id=08b9c2f2&scoped=true"
import script from "./xdd.vue?vue&type=script&lang=js"
export * from "./xdd.vue?vue&type=script&lang=js"
import style0 from "./xdd.vue?vue&type=style&index=0&id=08b9c2f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b9c2f2",
  null
  
)

export default component.exports